// 历史原因，大部分页面并未适配好 SPA 跳转，但有时候又需要用不同 url 区分页面

import { useCallback } from 'react';

// 临时使用该 hook
export function useFakeNavigate() {
  return useCallback((url: string) => {
    history.pushState(null, '', url);
  }, []);
}
